/* eslint-disable jsx-a11y/img-redundant-alt */
import { useSelector } from "react-redux";
import { Box, Card, Grid, Stack, Typography } from "@common-ui/ui";
// import InsertPhotoOutlinedIcon from "@mui/icons-material/InsertPhotoOutlined";
import { useEffect, useState } from "react";
import { getOrg, getOrgProfileImage } from "../../services";

const OrgCard = (props) => {
  const [orgImageFileType, setOrgImageFileType] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [currentOrg, setCurrentOrg] = useState(null);

  const workEvent = useSelector((state) => state.workEvent[props.eventId]);

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  async function init() {
    try {
      let payload = await getOrg(props.orgId);
      if (!payload) return;
      setCurrentOrg(payload);
      let { logo } = payload;
      if (logo && logo.length) {
        const imageType = logo
          .split("?")[0]
          .split("/")
          .slice(-1)[0]
          .split(".")[1];
        setOrgImageFileType(imageType);
      }
    } catch (error) {}
  }

  useEffect(() => {
    async function getImage() {
      try {
        const response = await getOrgProfileImage(
          currentOrg?.id,
          orgImageFileType
        );
        setImageUrl(response.data.url);
      } catch (error) {
        setImageUrl("");
        console.log(error);
      }
    }
    if (orgImageFileType?.length) getImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgImageFileType]);

  return (
    <Card sx={{ mb: "24px" }}>
      <Box>
        <Stack direction="row" justifyContent="space-between" sx={{ pb: 2 }}>
          <Typography sx={{ mt: 1 }} variant="h4" fontWeight="700">
            <Grid container spacing={2} sx={{ mt: 0, ml: 2 }}>
              {
                imageUrl && imageUrl.length > 0 ? (
                  <Grid
                    item
                    md={6}
                    xs={4}
                    display="flex"
                    justify="center"
                    alignItems="center"
                    columnSpacing={{ xs: 1 }}
                  >
                    <img
                      alt="profile-image"
                      src={imageUrl}
                      style={{
                        height: "3.4em",
                        width: "5.2em",
                        objectFit: "contain",
                      }}
                    />
                  </Grid>
                ) : (
                  " "
                )
                // <InsertPhotoOutlinedIcon
                //   fontSize="large"
                //   sx={{
                //     height: "2.4em",
                //     width: "5.2em",
                //   }}
                // />
              }

              <Grid item md={6} xs={6}>
                <Typography color="textPrimary" variant="h4" sx={{ mt: 2 }}>
                  {currentOrg?.name}
                </Typography>
                <Typography variant="body2">
                  {currentOrg?.street_address?.address_line_1}
                </Typography>
                <Typography variant="body2">
                  {currentOrg?.street_address?.address_line_2}
                </Typography>
                <Typography variant="body2">
                  {currentOrg?.street_address?.city}
                  {currentOrg?.street_address?.state_or_province}
                </Typography>
                <Typography variant="body2">
                  {currentOrg?.street_address?.country_or_region}
                  {currentOrg?.street_address?.postal_code}
                </Typography>
              </Grid>
            </Grid>
          </Typography>
          <Typography sx={{ mt: 1, p: 3 }} variant="h3" fontWeight="700">
            Summary Report
            <Typography variant="body2">Report: {workEvent?.id}</Typography>
          </Typography>
        </Stack>
      </Box>
    </Card>
  );
};

export default OrgCard;
